import Vue from "vue";
import axios from "axios";
import router from "../router";
import { Message } from "element-ui";

function GetUrlParam(paraName) {
  //截取token
  // return paraName.slice(paraName.indexOf("=")+1,paraName.indexOf("&"))
  var url = document.location.toString();
  var arrObj = url.split("?");
  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split("&");
    var arr;
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");
      if (arr != null && arr[0] === paraName) {
        return arr[1];
      }
    }
    return "";
  } else {
    return "";
  }
}
// axios.defaults.baseURL = 'https://api-dev.lejian.net'
// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (GetUrlParam("t")) {
      config.headers = {
        "Content-Type": "application/json",
        "access-token": "",
        token: GetUrlParam("t"),
        Authorization: ""
      };
    } else {
      config.headers = {
        "Content-Type": "application/json",
        "access-token": "",
        Authorization: ""
      };
    }

    let tokenId = localStorage.getItem("TOKEN");
    let lang = localStorage.getItem("lang");
    if (tokenId) {
      config.headers["user-token"] = tokenId;
      // config.headers['Authorization'] = 'JWT ' + tokenId;
    }
    if (lang) {
      config.headers["Accept-Language"] = lang;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    // console.log(response)
    if (response.data.code == 11005) {
      console.log(11005);
      Message({ message: response.data.message, type: "error" });
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = window.origin + "/#/";
    } else {
      if (response.data.success == false) {
        Message({ message: response.data.message, type: "error" });
      }
    }

    return response;
  },
  error => {
    Message({
      message: error.response.data.data.gender[0],
      type: "error",
      center: true,
      duration: 5000
    });
    return Promise.reject(error);
  }
);

//get请求
export const GET = (url, param) => {
  if (param) {
    return axios.get(url, {
      params: param
    });
  } else {
    return axios.get(url);
  }
};
//post请求
export const POST = (url, param, config) => {
  if (config) {
    return axios.post(url, param, config);
  } else {
    return axios.post(url, param);
  }
};

export const PUT = (url, param) => {
  return axios.put(url, param);
};

export const DELETE = url => {
  return axios.delete(url);
};



// WEBPACK FOOTER //
// ./src/utils/http.js